import Settings from '../olr-common/Settings';

export default function ClassRoomService($http) {
  let url = Settings.backendEnv + "/api/v1/classroom";

  this.saveClassRoom = function(classObj) {
    var req = {
      method:  "POST",
      url:    url,
      data:   classObj
    };

    return $http(req);
  };

  this.updateClassRoom = function(classObj){
    var req = {
      method:  "PUT",
      url:    url,
      data:   classObj
    };

    return $http(req);
  };

  this.getAllClassRooms = function(){
    return $http({method: 'GET',url: url});
  };

  this.deleteClassRoom = function(classObj) {
    var req = {
      method: "DELETE",
      url:    url + "/" + classObj.classRoomId
    };

    return $http(req);
  };

  this.getClassRoomDetails = function(classId, subId){
    var req = {
      method: "GET",
      url:    url + "/" + classId + "/" + subId
    };

    return $http(req);
  };

  this.getClassRoomStudents = function(classId, subId){
    var url1 = Settings.backendEnv + "/api/v1/classroomStudents" + "/" + classId + "/" + subId;
    console.log(url1);
    var req = {
      method: "GET",
      url:    url1
    };

    return $http(req);
  };
}

export function ClassRoomServiceStub($httpBackend) {
  $httpBackend
    .whenPOST('/mainv1/api/classroom')
    .respond(function(method, url, data) {
      let timestamp = new Date().getUTCMilliseconds();
      return [200, {classRoomId: timestamp}, {/* response header */}];
    });

  $httpBackend
    .whenGET('/mainv1/api/classroom')
    .respond(function(method, url, data) {
      var classRooms = localStorageService.get('classerroms');
      return [200, classRooms, {/* response header */}];
    });

  $httpBackend
    .whenPUT(/.*?mainv1\/api\/classroom?.*/g)
    .respond(function(method, url, data) {
      return [200, {classRoom: 'updated'}, {/* response header */}];
    });

  $httpBackend
    .whenDELETE(/.*?mainv1\/api\/classroom?.*/g)
    .respond(function(method, url, data) {
      return [200, {}, {/* response header */}];
    });
}




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/ClassRoomService.js
 **/